import React from 'react';
import { AssetsConstant } from '@vivli/shared/infrastructure/constants';
import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const WhiteBackgroundLogoComponent = () => {
    const { isAmr } = useAssignedAppTypeContext();
    return <img src={isAmr ? AssetsConstant.VIVLI_AMR_RGB_LOGO : AssetsConstant.VIVLI_LOGO} width={isAmr ? 340 : 314} height={111} />;
};
